import { animationFrameScheduler, BehaviorSubject, interval, of } from 'rxjs';
import { catchError, distinctUntilChanged, finalize, map, switchMap, throttleTime } from 'rxjs/operators';

const FPS = 1000 / 24;

const subject = new BehaviorSubject(undefined);

export default subject
  .pipe(
    distinctUntilChanged(),
    switchMap((stream) => {
      if (!stream) return of(0);

      const ctx = new AudioContext();
      const analyser = ctx.createAnalyser();
      analyser.fftSize = 2048;
      analyser.smoothingTimeConstant = 0.5;

      const mic = ctx.createMediaStreamSource(stream);
      mic.connect(analyser);

      const fftData = new Uint8Array(analyser.frequencyBinCount);
      return interval(0, animationFrameScheduler).pipe(
        throttleTime(FPS),
        map(() => {
          analyser.getByteFrequencyData(fftData);
          return Math.max(...fftData) / 255;
        }),
        finalize(() => {
          mic.disconnect();
          analyser.disconnect();
          ctx.close();
        })
      );
    }),
    catchError(() => of(0))
  )
  .asObservable();

export const stopStream = () => {
  subject
    .getValue()
    ?.getTracks()
    .forEach((t) => t.stop());
  subject.next(undefined);
};

export const setStream = (stream) => subject.next(stream);
